import { initCommerceApiWithGlobals } from 'common-api';
import { logger, isBrowser } from 'common-ui';
import type { AuthDetails } from 'tsconfig/types';
import { useAuthStore } from '../../stores/authStore';
import { formatTokenResponseToAuthAtomState } from './formatTokenResponseToAuthAtomState';

export const getAnonymousToken = async (): Promise<AuthDetails | undefined> => {
  if (!isBrowser()) {
    logger.log('getAnonymousToken skipping as not in browser');
    return;
  }

  try {
    const commerceApi = initCommerceApiWithGlobals();
    const token = await commerceApi.Auth.getAnonymousToken();
    const newAuthValue = formatTokenResponseToAuthAtomState(token);
    useAuthStore.getState().setAuth(newAuthValue);
    return newAuthValue;
  } catch (e) {
    logger.log('API ERROR', e);
    throw e;
  }
};
